<template>
    <Head title="Liste des articles" />

    <AppLayout>
        <div x-data="handleSelect">
            <Datatables>
                <template #title>
                    Liste des articles
                    <span class="font-medium">({{ items.total }})</span>
                </template>
                <template #headerButtons>
                    <button class="rounded-md py-1 px-2 bg-white text-sky hover:bg-sky-400 hover:text-white"
                        @click="showSearchModal" title="Rechercher"
                    >
                        <i class="fad fa-search"></i>
                    </button>
                </template>
                <template #tableHeader>
                    <th>#</th>
                    <th>Référence</th>
                    <th>Nom</th>
                    <th>prix</th>
                    <th>Client</th>
                    <th><i class="fab fa-whatsapp text-green-500 text-sm"></i></th>
                    <th>Statut</th>
                    <th class="px-2 first:pl-5 last:pr-5 py-3">
                        <span class="sr-only">Menu</span>
                    </th>
                </template>
                <template #tableBody>
                    <template v-if="!items.data.length">
                        <tr>
                            <td colspan="8">
                                <div class="text-center text-xl text-red-400 bg-red-100 p-8">
                                    Aucun article enregistré.
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else v-for="(item, index) in items.data" :key="index">
                        <tr>
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.reference }}</td>
                            <td>{{ item.short_name_table }}</td>
                            <td>
                                <div class="text-right font-bold"
                                    :class="item.balance > 0 ? 'text-gray-400' : 'text-primaryOrange'"
                                >{{ formatAmount(item.price, currency) }}</div>
                            </td>
                            <td>
                                <div v-if="item.customer" class="flex items-center">
                                    <div class="shrink-0 flex items-center justify-center bg-gray-700 rounded-full mr-2">
                                        <img class="w-10 h-10 rounded-full border-2 border-white box-content"
                                            :src="item.customer.profile_photo_url"
                                        />
                                    </div>
                                    <div class="grow text-left">
                                        <h2 class="font-semibold text-gray-800 inline-flex">{{ item.customer.name }}</h2>
                                        <div class="text-xs text-gray-500 font-semibold">{{ item.customer.full_phone }}</div>
                                    </div>
                                </div>
                                <span v-else class="text-yellow-500 italic font-semibold">Article non vendu</span>
                            </td>
                            <td>
                                <b :class="item.whatsapp_clicks > 0 ? 'text-greendack-500' : 'text-gray-400'">{{ item.whatsapp_clicks }}</b>
                            </td>
                            <td><StatusBadge :label="item.status_text" :color="item.status_color" /></td>
                            <td>
                                <Link class="flex justify-end" :href="route('travels.items.index', item.travel) + '?filter[reference]=' + item.reference"
                                    title="Détails"
                                >
                                    <svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                                        <path class="fill-current text-sky" d="M8.07 16H10V8H8.07a8 8 0 110 8z"></path>
                                        <path class="fill-current text-sky-300" d="M15 12L8 6v5H0v2h8v5z"></path>
                                    </svg>
                                </Link>
                            </td>
                        </tr>
                    </template>
                </template>
            </Datatables>
        </div>

        <Pagination :links="items.links" />

        <JetDialogModal :show="searchModal" @close="closeSearchModal" max-width="xl">
            <template #title>Recherche un article</template>

            <template #content>
                <GlobalFilter @search-launched="closeSearchModal" />
            </template>
        </JetDialogModal>
    </AppLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import AppLayout from '@/Layouts/AppLayout.vue'
    import Pagination from '@/Components/Pagination'
    import Datatables from '@/Components/Datatables'
    import PackageForm from '@/Components/PackageForm'
    import StatusBadge from '@/Components/StatusBadge'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import GlobalFilter from '@/Components/GlobalFilter'
    import CurrencyMixins from '@/Mixins/CurrencyMixins'
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import DateFormatMixins from '@/Mixins/DateFormatMixins'

    export default defineComponent({
        components: {
            Head,
            Link,
            AppLayout,
            Pagination,
            Datatables,
            StatusBadge,
            PackageForm,
            GlobalFilter,
            JetDialogModal
        },

        mixins: [ DateFormatMixins, CurrencyMixins],

        props: {
            items: Object
        },

        data() {
            return {
                searchModal: false
            }
        },

        methods: {
            showSearchModal () {
                this.searchModal = true
            },

            closeSearchModal() {
                this.searchModal = false
            },
        }
    })
</script>
